import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCircleNotch,
    faExclamationTriangle,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCheck,
    faTimes,
    faTimesCircle,
    faEraser,
    faLandmark,
    faFileUpload,
    faFileDownload,
    faCopy
} from '@fortawesome/free-solid-svg-icons'
import {faYoutube, faGoogle, faApple, faFacebook} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(
    faCircleNotch,
    faExclamationTriangle,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCheck,
    faTimes,
    faTimesCircle,
    faEraser,
    faFileUpload,
    faFileDownload,
    faLandmark,
    faCopy,
    faYoutube,
    faGoogle,
    faApple,
    faFacebook
)

Vue.component('font-awesome-icon', FontAwesomeIcon)